import ABCyaLib from '@abcya/abcya_lib';

export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    bodyIndentString: "     "
  };
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
  }
  switch (locale) {
    case ABCyaLib.Environment.LOCALES.esUS:
      config.bodyIndentString = "";
      break;
  }
  return config;
}